import { FC, useEffect } from 'react'
import { DetailOrder } from 'entities/orders/model'
import {
    CheckoutPaymentsStyled,
    DetailsPaymentsTitle,
    Total,
    WrapperItems,
} from './style'
import { Counterparty } from 'entities/counterparties/model'
import { CounterItem } from './CounterItem'
import { useOrderController } from '../hooks/useOrderController'

interface CheckoutPaymentsProps {
    detailOrder: DetailOrder
    counterparty: Counterparty
    onGetFullBookingData?: (bookingId: number) => any
    onGetFullNomenclatureData?: (bookingId: number, nomenclatureId: number) => any
    setSelectedBookingsFromCheckout: any
}

export const CheckoutPayments: FC<CheckoutPaymentsProps> = ({
    detailOrder,
    counterparty,
    onGetFullBookingData,
    onGetFullNomenclatureData,
    setSelectedBookingsFromCheckout
}) => {

    const {
        totalPrice,
        selectedBookings,
        originalOrder,
        onChangeNomenclaturesCount,
        getNomenclaturesCount,
        isBookingChecked,
        isNomenclatureChecked,
        onChangeBookingsToRefund,
        onChangeBookingsAreaCountToRefund,
        getAreaCount,
    } = useOrderController()

    if (!originalOrder) {
        return <>Заказ не найден</>
    }

    const getFullBookingData = (bookingId: number) => {
        return onGetFullBookingData ? onGetFullBookingData(bookingId) : detailOrder?.bookings.find(b => b.id === bookingId)
    }

    const getFullNomenclatureData = (bookingId: number, nomenclatureId: number) => {
        return onGetFullNomenclatureData ? onGetFullNomenclatureData(bookingId, nomenclatureId) : getFullBookingData(bookingId)?.nomenclatures.find((n: any) => n.id === nomenclatureId)
    }

    /* eslint-disable react-hooks/rules-of-hooks */
    useEffect(() => {
        if (detailOrder?.bookings && selectedBookings.length > 0) {
            setSelectedBookingsFromCheckout(selectedBookings.map(selected => {
                return {
                    ...selected,
                }
            }))
        }
    }, [selectedBookings, detailOrder])
    
    return (
        <CheckoutPaymentsStyled>
            <div className='row'>
                <DetailsPaymentsTitle>Ваш заказ</DetailsPaymentsTitle>
                
                {originalOrder.bookings.map((booking, index) => (
                    <CounterItem
                        booking={booking}
                        key={index}
                        onChangeBookingsToRefund={onChangeBookingsToRefund}
                        isBookingChecked={isBookingChecked}
                        isNomenclatureChecked={isNomenclatureChecked}
                        onChangeNomenclaturesCount={onChangeNomenclaturesCount}
                        getNomenclaturesCount={getNomenclaturesCount}
                        onChangeBookingsAreaCountToRefund={
                            onChangeBookingsAreaCountToRefund
                        }
                        getAreaCount={getAreaCount}
                    />
                ))}

            </div>
            <div className='row'>
                <div className='line'></div>
                <WrapperItems>
                    {selectedBookings.map((item, index) => {
                        const fullBooking = getFullBookingData(item.booking_id)
                        console.log('fullBooking', fullBooking)
                        return (
                            <div key={index}>
                                <div className='item'>
                                    <span className='item-title'>
                                        {fullBooking?.area?.name} ({item.area_hours?.count || 0}ч)
                                    </span>
                                    <div className='item__left'>
                                        <div className="item__areaPrice">₽ {fullBooking?.areaPrice || 0}</div>
                                        <div className='item__areaTotalPrice'>
                                            ₽ {fullBooking?.areaTotalPriceWithDiscount || 0}
                                        </div>
                                    </div>
                                </div>
                                {item.nomenclatures?.map((nomenclature, nomIndex) => {
                                    const fullNomenclature = getFullNomenclatureData(item.booking_id, nomenclature.id)
                                    console.log('fullNomenclature', fullNomenclature)
                                    return (
                                        <div key={nomIndex} className='itemNomenclature'>
                                            <span className='item-title' style={{ fontWeight: '400' }}>
                                                {fullNomenclature?.name} (x{nomenclature.count})
                                            </span>
                                            <div className='item__left'>
                                                <div className="item__areaPrice">₽ {fullNomenclature?.price || 0}</div>
                                                <div className='item__areaTotalPrice'>
                                                    ₽ {fullNomenclature?.totalPrice || 0}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
                    <div className='item'>
                        <span className='item-title'  style={{ fontWeight: '400' }}>Скидка клиента</span>
                        <div className='item__left'>
                            <div className='item-price'>
                                ₽ {counterparty.discount}
                            </div>
                        </div>
                    </div>
                </WrapperItems>
                <div className='line'></div>
                <Total>
                    <div>Итого</div>
                    <div>₽ {totalPrice}</div>
                </Total>
            </div>
        </CheckoutPaymentsStyled>
    )
}
